function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "z",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#46C1F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#29AAE2"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#z)",
  fillRule: "nonzero",
  d: "M21.07 3C22.69 3 24.005 4.302 24 5.897v12.21C24 19.704 22.684 21 21.065 21H2.935C1.316 21 0 19.703 0 18.108V5.892C0 4.297 1.316 3 2.935 3zm-.005 1.326H2.935c-.88 0-1.594.705-1.594 1.571v12.21c0 .867.715 1.572 1.594 1.572H21.07c.88 0 1.594-.705 1.594-1.571h-.005V5.898c0-.867-.715-1.572-1.594-1.572zM2.994 5.76a.672.672 0 0 1 .942-.054l6.385 5.634c.04.029.074.058.109.092 0 .005.005.01.01.015l1.569 1.381 8.043-7.117a.676.676 0 0 1 .942.049.653.653 0 0 1-.049.929l-5.832 5.156 5.857 5.483a.653.653 0 0 1 .024.93.67.67 0 0 1-.483.204.667.667 0 0 1-.46-.18l-5.93-5.556-1.663 1.47a.667.667 0 0 1-.888.004L9.95 12.775l-5.966 5.502a.673.673 0 0 1-.942-.034.653.653 0 0 1 .03-.93l5.876-5.424-5.901-5.2a.65.65 0 0 1-.054-.93z",
  transform: "translate(0 -3)"
});

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.d32263a0.svg";
export { ForwardRef as ReactComponent };